import { FormControl } from '@angular/forms';
import { AutomatedOooiData } from './automated-oooi-data.model';
import { sanitizeServerUtcDate } from '@sd-portal/shared/util';

export class AutomatedOooiDataForm {
  automatedOutTime: FormControl;
  automatedOffTime: FormControl;
  automatedOnTime: FormControl;
  automatedInTime: FormControl;

  // index signature
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(automatedData: AutomatedOooiData) {
    if (automatedData) {
      const datesToSanitize = [
        'automatedOutTime',
        'automatedOffTime',
        'automatedOnTime',
        'automatedInTime'
      ];

      datesToSanitize.forEach(dateToSanitize => {
        if (automatedData[dateToSanitize]) {
          this[dateToSanitize] = new FormControl(
            sanitizeServerUtcDate(automatedData[dateToSanitize])
          );
        }
      });
    }
  }
}
